jQuery(document).ready(function ($) {
  jQuery('#newSliderContainer').slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 6000,
    cssEase: 'linear',
    dots: false,
    duration: 1500,
    fade: true,
    infinite: true,
    speed: 150,
  })
})